import type { ComputedRef } from 'vue';
import { ApiFitnessData } from '@/rennovation/planning-view/types/api/roster-response';
import { useDateTime } from '../../../../components/composables/useDateTime.js';

export function useDriverDebugCellHelpers(manualWorktimeBalances: ComputedRef<Array<{ day: { id: string }; amount: number }>>) {
	const fitnessDataTimeKeys = [
		'Rest_restAfterDuty',
		'WorkTime_workTime',
		'WorkTime_workShiftHistory7days',
		'DutyTime_dutyTimeHistory28days',
		'DutyTime_dutyTimeSum',
		'ConsistentShift_middle',
		'DailyRest_restHistory28days',
		'DailyRest_restSum',
		'RestDay_offDaysRest',
		'RestDay_restDayHistory42days',
		'RestDay_secondsPerDayHistory42days',
		'RestDay_offDaysRestHistory42days',
		'RestDay_restAfterDutyHistory42days',
		'WorkTime_workTimeBalance',
		'WorkTime_workTimeBalanceExpected',
	];
	const { formatSecondsDuration, formatTimeToSeconds } = useDateTime();

	function getManualAmount(dayId: string | undefined): string {
		if (!dayId) return '';
		const bal = manualWorktimeBalances?.value?.find((b) => b.day.id === dayId);
		return bal ? String(bal.amount) : '';
	}

	function secondsArrayToTime(secondsArray: Array<number | null>): string {
		let string = '[';
		for (const index in secondsArray) {
			if (index !== '0') {
				string += ',';
			}
			string += ' ';
			string += secondsArray[index] === null ? 'null' : formatSecondsDuration(secondsArray[index]);
		}
		string += ' ]';
		return string;
	}

	function renderFitnessCell(data: ApiFitnessData | null, key: string): string {
		const val = data?.[key];
		if (val === null || val === undefined) return '';

		if (fitnessDataTimeKeys.includes(key)) {
			return Array.isArray(val) ? secondsArrayToTime(val) : formatSecondsDuration(val as number);
		}

		if (typeof val === 'object') return JSON.stringify(val);
		return String(val);
	}

	return {
		getManualAmount,
		renderFitnessCell,
	};
}
